import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';

export class DateValidators {
  /**
   * Validator to check if the end date is greater than the start date.
   * @param startControl The control containing the start date.
   * @returns A validation function that checks if the end date is greater than the start date.
   */
  static greaterThan(startControl: AbstractControl): ValidatorFn {
    return (endControl: AbstractControl): ValidationErrors | null => {
      const startValue: Date | null = this.convertNgbDateToIsoDate(startControl.value);
      const endValue: Date | null = this.convertNgbDateToIsoDate(endControl.value);
      if (!startValue || !endValue) {
        return null;
      }

      if (startValue >= endValue) {
        return { greaterThan: true };
      }
      return null;
    };
  }

  /**
   * Validator to check if the end date is greater or equal than the start date.
   * @param startControl The control containing the start date.
   * @returns A validation function that checks if the end date is greater than the start date.
   */
  static greaterEqualThan(startControl: AbstractControl): ValidatorFn {
    return (endControl: AbstractControl): ValidationErrors | null => {
      const startValue: Date | null = this.convertNgbDateToIsoDate(startControl.value);
      const endValue: Date | null = this.convertNgbDateToIsoDate(endControl.value);
      if (!startValue || !endValue) {
        return null;
      }

      console.log('startValue', startValue);
      if (startValue > endValue) {
        return { greaterEqualThan: true };
      }
      return null;
    };
  }

  private static convertNgbDateToIsoDate(date?: NgbDate): Date | null {
    return date
      ? new Date(date.year + '-' + date.month.toString().padStart(2, '0') + '-' + date.day.toString().padStart(2, '0'))
      : null;
  }
}
